const castArray = (a) => Array.isArray(a) ? a : [a];
export {
  castArray
};
//# sourceMappingURL=castArray.js.map
